import { app } from '../../../../../../app';
import { Controller } from './add-new-group.controller';

app.component('companyUserDirectoriesDirectoryGroupsDirectoryAddNewGroup', {
    bindings: {companyId: '<'},
    controller: Controller,
    templateUrl: require('./add-new-group.html'),
});



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/directory-groups/directory/add-new-group/add-new-group.component.js